import * as React from 'react';

import { ToggleSwitch, FormCheckConditional, TextInput } from '../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur?: (value?: {}) => void;
	onQuestionnaireChange: (e: any) => void;
}
class AlchoholConsumptionQuestion extends React.Component<Props> {
	render() {
		const { questions, questionnaire, onQuestionnaireBlur, onQuestionnaireChange } = this.props;
		return (
			<ToggleSwitch
				labelText={questions.consumedAlcohol}
				name="consumedAlcohol"
				onChildren="Yes"
				offChildren="No"
				onBlur={onQuestionnaireBlur}
				onChange={onQuestionnaireChange}
				checked={questionnaire.consumedAlcohol}
				className="toggle-yes-no"
				conditionalChildren={(
					<FormCheckConditional isOpen={questionnaire.consumedAlcohol} className="ml-0">
						<div className="form-group mb-0">
							<div className="form-inline-p">
								<div
									className="form-inline-p-text"
									dangerouslySetInnerHTML={{ __html: questions.drinksStart as any }}
								/>
								<TextInput
									name="drinksPerWeekday"
									className="form-group-number"
									pattern="[0-9]*"
									value={questionnaire.drinksPerWeekday}
									onBlur={onQuestionnaireBlur}
									onChange={onQuestionnaireChange}
								/>
								<div
									className="form-inline-p-text"
									dangerouslySetInnerHTML={{ __html: questions.drinksPerWeekday as any }}
								/>
								<TextInput
									name="drinksPerWeekend"
									className="form-group-number"
									pattern="[0-9]*"
									value={questionnaire.drinksPerWeekend}
									onBlur={onQuestionnaireBlur}
									onChange={onQuestionnaireChange}
								/>
								<div
									className="form-inline-p-text"
									dangerouslySetInnerHTML={{ __html: questions.drinksPerWeekend as any }}
								/>
								<TextInput
									name="drinksPerSitting"
									className="form-group-number"
									pattern="[0-9]*"
									value={questionnaire.drinksPerSitting}
									onBlur={onQuestionnaireBlur}
									onChange={onQuestionnaireChange}
								/>
								<div
									className="form-inline-p-text"
									dangerouslySetInnerHTML={{ __html: questions.drinksPerSitting as any }}
								/>
							</div>
						</div>
					</FormCheckConditional>
				)}
			/>
		);
	}
}
export default AlchoholConsumptionQuestion;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/activitiesQuestions/AlchoholConsumptionQuestion.tsx